import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { CenterProgram } from './center-program.model'
import { HubCourseTimetable} from './hub-course-timetable.model'
import { Hub} from './hub.model'
import { Infraction } from './infraction.model'
import { HubCoursePremoderation } from './hub-course-premoderation.model'
import { TranslateService } from '@ngx-translate/core'
import { APP_INJECTOR } from 'app.module'

export class HubCourse extends BaseModel<HubCourse> {
   static DEFAULT_ATTRIBUTES = {
    sharedCoursesIds: []
  }

  id: number
  name: string
  centerProgram: CenterProgram
  centerProgramId: number
  hubCourseTimetable: HubCourseTimetable
  sharedCoursesIds: number[]
  sharedCoursesOptions: Object[]
  hubCoursePremoderation: HubCoursePremoderation
  hub: Hub
  registerFrom: number
  registerTo: number
  position: number
  infractionIds: number[]
  virtualQueueEnabled: boolean
  infractions: Infraction[]
  state: string
  registrationSmsId: number

  constructor(attributes) {
    super(attributes)

    if (this.sharedCoursesOptions) {
      this.sharedCoursesOptions = this.sharedCoursesOptions.map(sc => {
        return { value: sc['id'], label: APP_INJECTOR.get(TranslateService).instant('hubs.courses.' + sc['name']) }
      })
    }
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub-course.model.ts